import {
  FORMAT_UNIX_MS,
  format,
  now,
  stringToDate,
  isAfter,
  differenceInMilliseconds,
} from 'helpers/DateTimeHelper';

const ON_NOW = 'ON_NOW';
const ON_TONIGHT = 'ON_TONIGHT';
const WAS_ON = 'WAS_ON';

export function getStartTimestamp(listing) {
  const { startDate } = listing;
  return format(stringToDate(startDate), FORMAT_UNIX_MS);
}

export function getEndTimestamp(listing) {
  const { endDate } = listing;
  return format(stringToDate(endDate), FORMAT_UNIX_MS);
}

export function whenLiveStreamIsOn(listings) {
  const [first] = listings;
  const [last] = listings.slice(-1);
  const timeFirstStart = getStartTimestamp(first);
  const timeLastEnd = getEndTimestamp(last);
  const timeNow = format(now(), FORMAT_UNIX_MS);
  if (timeNow < timeFirstStart) {
    return ON_TONIGHT;
  }
  if (timeNow > timeLastEnd) {
    return WAS_ON;
  }
  return ON_NOW;
}

function isLiveStreamOn(listings) {
  return whenLiveStreamIsOn(listings) === ON_NOW;
}

export function getLiveListing(listings) {
  let listing = {};
  listings.forEach(item => {
    if (isLiveStreamOn([item])) {
      listing = item;
    }
  });

  return listing;
}

export function getLiveProgress(opts = {}) {
  const { startDate, endDate } = opts;
  if (!startDate || !endDate) return null;

  const current = now();
  const starts = stringToDate(startDate);
  const ends = stringToDate(endDate);

  const videoStarted = isAfter(now(), starts);
  const videoEnded = isAfter(now(), ends);

  if (!videoStarted) return 0;
  if (videoEnded) return 100;

  const durationMs = differenceInMilliseconds(ends, starts);
  const progressMs = differenceInMilliseconds(current, starts);

  let liveProgress = (progressMs / durationMs) * 100;
  if (liveProgress > 100) liveProgress = 100;
  return liveProgress;
}
